import GenericWarningModal from './GenericWarningModal'

export default GenericWarningModal
